<div class="row">
  <div>&#169; 2021 by ExploSYS GmbH</div>
</div>
